import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import WhatsappApi from "../../components/Admin/profileComps/whatsappConnect"

const ConnectWhatsapp = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Connect Whatsapp | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <WhatsappApi />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default ConnectWhatsapp
